import React from "react";

const CustomerContext = React.createContext();

const CustomerProvider = CustomerContext.Provider;

export { CustomerProvider, CustomerContext };
